import React, {useEffect, useMemo, useRef} from 'react'
import PropTypes from 'prop-types'
import {Box} from '@salesforce/retail-react-app/app/components/shared/ui'
import {getConfig} from '@salesforce/pwa-kit-runtime/utils/ssr-config'
import useDebouncedValue from '../../../../hooks/use-debounced-value'

const UPDATE_DELAY = 500

const AfterPayMessage = ({price, variant, placement = 'primary'}) => {
    const containerRef = useRef(null)
    const {
        app: {commerceAPI}
    } = getConfig()
    const {afterpay} = commerceAPI
    const {configAfterpay} = afterpay || {}

    var enablePDPCallout = false
    var apJavaScript = null
    var apPdpPlacementId = null
    var apPdpMpId = null

    try {
        const jsonConfig = JSON.parse(configAfterpay)

        enablePDPCallout = jsonConfig.enablePDPCallout
        apJavaScript = jsonConfig.scriptURL
        apPdpPlacementId = jsonConfig.pdpPlacementID
        apPdpMpId = jsonConfig.pdpMPID
    } catch (e) {
        console.log(e.message)
    }

    const selection = useMemo(
        () => ({price, productId: variant?.productId}),
        [price, variant?.productId]
    )
    const displayedSelection = useDebouncedValue(selection, UPDATE_DELAY)

    useEffect(() => {
        if (apJavaScript && !document.querySelector(`script[src="${apJavaScript}"]`)) {
            const script = document.createElement('script')
            script.src = apJavaScript
            script.async = true
            script.defer = true
            document.body.appendChild(script)
        }
    }, [apJavaScript])

    return (
        enablePDPCallout &&
        apPdpMpId &&
        apPdpPlacementId &&
        apJavaScript && (
            <Box
                id={`afterpay-message-${placement}`}
                ref={containerRef}
                sx={{
                    'afterpay-placement': {
                        '--messaging-font-size': '12px',
                        margin: 0,
                        '--messaging-font-weight': '300',
                        '--logo-badge-width': '65px',
                        color: 'black.100',
                        fontWeight: '300'
                    }
                }}
            >
                <afterpay-placement
                    data-locale="en_US"
                    data-cart-is-eligible="true"
                    data-is-eligible="true"
                    data-consumer-locale="en_US"
                    data-amount={displayedSelection.price}
                    data-placement-id={apPdpPlacementId}
                    data-modal-link-style="circled-info-icon"
                    data-mpid={apPdpMpId}
                    data-currency="USD"
                    data-size="12"
                    data-badge-theme="white-on-black"
                    data-page-type="product"
                    data-platform="SFCC/SFRA"
                    data-item-skus={displayedSelection.productId}
                ></afterpay-placement>
            </Box>
        )
    )
}

AfterPayMessage.propTypes = {
    price: PropTypes.number,
    placement: PropTypes.oneOf(['primary', 'secondary']),
    variant: PropTypes.shape({
        price: PropTypes.number,
        productId: PropTypes.string
    })
}

export default AfterPayMessage
